export default "__VITE_ASSET__ggKb8Q7P__"